import CbankService from "../../service/CbankService";
// import 'v-slim-dialog/dist/v-slim-dialog.css';
// import SlimDialog from 'v-slim-dialog';
// import SlimDialog from '@/v-slim-dialog'

export const namespaced = true

export const state = {
    cbankLoading: false,
    response: {}
}

export const getters = {
}


export const mutations = {
    updateDocuments: (state, payload) =>{
      state.documents = payload
    },
    updateDocumentsAdmin: (state, payload) =>{
      state.documentsAdmin = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
    updateIsDocumentsUpt: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.isDocumentsUpt = payload;
    },
    updateCbankLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.cbankLoading = payload;
    },
    reset: (state, payload) =>{
        state.cbankLoading = payload;
        state.response ={};
    },

}


export const actions = {
    createCbank: ({ commit }, payload)=>{
        // console.log("updateDocuments>>>>>>")
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateCbankLoading", true)
            return CbankService.callCreateCbankApi(payload)
            .then(response => {
                commit("updateCbankLoading", false)
                if (response.data.responseCode === "00") {
                    // commit("updateIsUserInfoUpt", true)
                    const options = {title: 'Success!', size: 'sm'}
                    dialogs.alert('Profile Created Successfully. Kindly check Email for further info', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        })
                }else{
                    const options = {title: 'Error!', size: 'sm'}
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        })
                }

            })
            .catch(error => {
                commit("updateCbankLoading", false)
                alert(error)
                // throw error;
            });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
